import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useDayTripPlanIsRoomPriceFree } from "./hooks";

export const QuestionPlanIsRoomPriceFree = () => {
	const { isRoomPriceFree, onSetIsRoomPriceFree: _onSetIsRoomPriceFree } = useDayTripPlanIsRoomPriceFree();

	const onSetIsRoomPriceFree = (input: boolean) => {
		_onSetIsRoomPriceFree(input);
	};

	const label = "部屋の料金を無料にする";
	const guide =
		"日帰りプランで選択される部屋の料金を無料に設定することができます。<br />ダミーの部屋を利用する場合など、部屋の料金を取らずに販売したい場合に選択してください。<br />サイトコントローラーの仕様上、部屋を販売するためには部屋の料金を1円以上で流し込んでおく必要があります。流し込まれた部屋の料金が0円の場合は、売り止めになります。<br />一方、部屋の料金がいくらであっても、このプランを介した予約の場合は部屋料金が無料で販売されます。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label}
			guide={guide}
			isEdited={isRoomPriceFree.isEdited}
			hasError={Boolean(isRoomPriceFree.error)}
			inputChildren={
				<CheckboxField
					value={isRoomPriceFree.value}
					label={"このプランを選択した場合、お部屋の料金が無料になるようにする"}
					handleChange={onSetIsRoomPriceFree}
					errorMessage={isRoomPriceFree.error}
				/>
			}
		/>
	);
};

QuestionPlanIsRoomPriceFree.displayName = "QuestionPlanIsRoomPriceFree";
